import { render, staticRenderFns } from "./legal-entity-modal.vue?vue&type=template&id=985e7a8c&scoped=true&"
import script from "./legal-entity-modal.vue?vue&type=script&lang=js&"
export * from "./legal-entity-modal.vue?vue&type=script&lang=js&"
import style0 from "./legal-entity-modal.vue?vue&type=style&index=0&id=985e7a8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "985e7a8c",
  null
  
)

export default component.exports